import { useQuery } from "@tanstack/react-query";
import { api } from "../client.ts";
import { queryKeys } from "../query-keys.ts";

export function useUserSelect() {
  return useQuery({
    queryKey: queryKeys.users.all,
    queryFn: async () => {
      const res = await api.userApi.apiUsersGetCollection();
      return res.data;
    },
    meta: {
      skipGlobalError: false,
    },
  });
}
